/**
 * DEV-3011 — Rapor alanlarının sihirbazdaki grup başlıkları.
 * Katalog (rapor_alanlari) grup bilgisi taşımadığı için gruplama istemcide,
 * alan koduna göre yapılır. Haritada olmayan kod "Diğer" grubuna düşer.
 */

export enum RaporAlanGrup {
  DosyaBilgileri = "Dosya Bilgileri",
  Taraflar = "Taraflar",
  Finansal = "Finansal",
  Harclar = "Harçlar",
  Faiz = "Faiz",
  Tahsilat = "Tahsilat",
  Masraf = "Masraf",
  Tebligat = "Tebligat",
  Notlar = "Notlar",
  HacizMalVarligi = "Haciz & Mal Varlığı",
  Diger = "Diğer",
}

// Sihirbazdaki gösterim sırası
export const RaporAlanGrupSirasi: RaporAlanGrup[] = [
  RaporAlanGrup.DosyaBilgileri,
  RaporAlanGrup.Taraflar,
  RaporAlanGrup.Finansal,
  RaporAlanGrup.Harclar,
  RaporAlanGrup.Faiz,
  RaporAlanGrup.Tahsilat,
  RaporAlanGrup.Masraf,
  RaporAlanGrup.Tebligat,
  RaporAlanGrup.Notlar,
  RaporAlanGrup.HacizMalVarligi,
  RaporAlanGrup.Diger,
];

const grupTanimlari: { [grup: string]: string[] } = {
  [RaporAlanGrup.DosyaBilgileri]: [
    "kart_no", "takip_dosya_esas_no", "kurum_dosya_no", "mts_esas_no",
    "aktar_takip_kart_no", "tuketici_kodu", "icra_dairesi", "vergi_no",
    "takip_tipi_aciklama", "takip_alt_tipi", "takip_yolu_isim", "takip_mahiyeti",
    "takip_durumu", "takip_etiketi", "takip_tarihi", "kapanis_tarihi",
    "dosya_sorumlusu",
  ],
  [RaporAlanGrup.Taraflar]: [
    "alacakli_adi_soyadi", "alacakli_kurum_adi", "alacakli_tc_kimlik_no",
    "alacakli_vergi_no", "alacakli_adresi", "alacakli_kurum_adresi",
    "alacakli_iletisim_bilgileri", "alacakli_vekili_ad_ve_soyadi",
    "borclu_adi_ve_soyadi", "borclu_kurum_isim", "borclu_tckn", "borclu_vergi_no",
    "borclu_adresi", "borclu_kurum_adresi", "borclu_iletisim_bilgileri",
    "borclu_vekilin_adi_ve_soyadi", "taraf_turu",
  ],
  [RaporAlanGrup.Finansal]: [
    "takip_toplami", "genel_toplam", "kalan_tutar", "asil_alacak",
    "asil_alacak_para_birimi", "harca_esas_deger", "cek_tazminati", "komisyon",
    "cezai_sart", "ihtar_masrafi", "protesto", "ihtiyati_haciz_masrafi",
    "ihtiyati_haciz_vekalet_ucreti", "vekalet_ucreti",
  ],
  [RaporAlanGrup.Harclar]: [
    "harc_adi", "harc_tutari", "harc_turu_toplam_tutar", "tahsil_harci",
    "tahsil_harci_orani", "cezaevi_harci", "basvuru_harci", "pesin_harc",
    "basvuru_pesin_harc", "vekalet_harci", "vekalet_basvuru_pesin_harc",
  ],
  [RaporAlanGrup.Faiz]: [
    "takip_oncesi_faiz", "takip_sonrasi_faiz", "faiz_orani_yuzde",
    "faiz_orani_yuzde_takip_oncesi", "faiz_orani_yuzde_takip_sonrasi",
    "faiz_periyodu", "takip_oncesi_bsmv", "takip_sonrasi_bsmv",
  ],
  [RaporAlanGrup.Tahsilat]: [
    "tahsilat_turu", "tahsilat_tutari", "tahsilat_tarihi", "tahsilat_toplami",
    "tahsilat_para_birimi", "son_tahsilat_tarihi", "takip_oncesi_tahsilat_toplami",
    "takip_sonrasi_tahsilat_toplami", "tahsil_edilen_borclu_kisi",
    "tahsil_edilen_borclu_kurum", "icra_dairesi_odenen", "avukata_odenen",
    "vekalet_ucret_belge_no",
  ],
  [RaporAlanGrup.Masraf]: [
    "masraf_tarihi", "masraf_tutari", "masraf_toplami", "masraf_cesidi",
    "masraf2_toplami_resmi", "masraf2_toplami_gr", "son_masraf_tarihi",
    "alacak_kalemi_aciklama",
  ],
  [RaporAlanGrup.Tebligat]: [
    "barkod_no", "tebligat_sekli", "tebligat_gonderim_tarihi", "tebligat_durumu",
  ],
  [RaporAlanGrup.Notlar]: [
    "notlar", "not_turu", "not_giris_tarihi",
  ],
  [RaporAlanGrup.HacizMalVarligi]: [
    "haciz_tarihi", "haciz_turu", "talep_tarihi", "arac_turu", "arac_modeli",
    "arac_markasi", "arac_plakasi", "arac_sase_no", "arac_motor_no",
    "arac_model_yili", "arac_ozellikleri", "isveren_adi", "isveren_adres",
    "muzakere_adres", "hisse_kar_payi_turu", "hisse_kar_payi_mersis_no",
    "hisse_kar_payi_sirket_adi", "tasinirlar_merhunun_ne_oldugu",
    "tasinmazlar_merhunun_ne_oldugu",
  ],
};

// kod -> grup (tek geçişte kurulur)
const kodGrupHaritasi: { [kod: string]: RaporAlanGrup } = {};
Object.keys(grupTanimlari).forEach((grup) => {
  grupTanimlari[grup].forEach((kod) => {
    kodGrupHaritasi[kod] = grup as RaporAlanGrup;
  });
});

export function raporAlanGrubu(kod: string | null | undefined): RaporAlanGrup {
  if (!kod) return RaporAlanGrup.Diger;
  return kodGrupHaritasi[kod] ?? RaporAlanGrup.Diger;
}

/**
 * "Sadece Temel Alanlar" kısayolu — tasarımdaki 23 alanın katalogdaki karşılıkları
 * (docs/DEV-3011/sonuc/08-tasarim-kod-farki.md §8.3 eşlemesi).
 */
export const TemelAlanKodlari: string[] = [
  "kart_no", "takip_dosya_esas_no", "icra_dairesi", "takip_durumu",
  "takip_tipi_aciklama", "takip_yolu_isim", "takip_tarihi", "dosya_sorumlusu",
  "alacakli_adi_soyadi", "alacakli_kurum_adi",
  "borclu_adi_ve_soyadi", "borclu_kurum_isim", "borclu_tckn", "borclu_vergi_no",
  "asil_alacak", "takip_toplami", "tahsilat_toplami", "kalan_tutar",
  "vekalet_ucreti", "harc_turu_toplam_tutar", "masraf_toplami", "tebligat_durumu",
];
